import React from 'react';
export function AgentSection() {
  return <section id="agent" className="bg-brand-dark py-16 md:py-32 px-5 md:px-12 lg:px-24 border-y border-brand-grey/20" data-id="element-1">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-10 md:gap-16" data-id="element-2">
        <div className="w-40 h-40 md:w-64 md:h-64 bg-brand-dark border border-brand-gold/40 flex-shrink-0 flex items-center justify-center" data-id="element-3">
          <span className="font-mono text-brand-grey/50 text-xs uppercase tracking-label text-center px-4" data-id="element-4">
            Agent
            <br data-id="element-5" />
            Photo
          </span>
        </div>

        <div className="flex flex-col text-center md:text-left pt-0 md:pt-6" data-id="element-6">
          <h2 className="font-display uppercase text-brand-white text-2xl md:text-3xl tracking-wide" data-id="element-7">
            Agent Name
          </h2>
          <p className="font-mono text-brand-grey text-xs uppercase tracking-wider mt-2" data-id="element-8">
            Senior Commercial Agent
          </p>
          <p className="font-mono text-brand-grey text-xs uppercase tracking-wider mt-1" data-id="element-9">
            Agency Name
          </p>

          <div className="mt-5 md:mt-6 flex flex-col gap-3" data-id="element-10">
            <a href="tel:04XXXXXXXX" className="font-mono text-brand-gold text-sm hover:text-brand-white active:text-brand-white transition-colors py-1" data-id="element-11">
              04XX XXX XXX
            </a>
            <a href="mailto:agent@agency.com.au" className="font-mono text-brand-gold text-sm hover:text-brand-white active:text-brand-white transition-colors py-1" data-id="element-12">
              agent@agency.com.au
            </a>
          </div>

          <p className="font-body font-light text-brand-grey text-sm mt-6 md:mt-8 max-w-md" data-id="element-13">
            For a private inspection or further information, contact us
            directly.
          </p>
        </div>
      </div>
    </section>;
}